<template>
    <aside aria-label="Login">
        <slide-in-overlay :is-open="isOpen" @close="close" class="c-login">
            <template v-slot:heading> {{ translations['Log in'] }} </template>

            <template v-slot:body>
                <div v-if="showLogin">
                    <div class="o-input">
                        <input
                            class="o-input__input"
                            type="text"
                            name="username"
                            id="login-username"
                            required="required"
                            :class="{
                                'o-input__input--filled': username,
                            }"
                            v-model="username"
                        />
                        <label for="login-username" class="o-input__label">
                            {{ translations['Email'] }}
                        </label>
                    </div>

                    <div class="o-input">
                        <input
                            class="o-input__input"
                            type="password"
                            name="password"
                            id="login-password"
                            required="required"
                            :class="{
                                'o-input__input--filled': password,
                            }"
                            v-model="password"
                        />
                        <label for="login-password" class="o-input__label">
                            {{ translations['Password'] }}
                        </label>
                    </div>
                    <div class="c-login__actions">
                        <div
                            class="c-login__button"
                            :class="{ 'c-login__button--loading': isLoading }"
                        >
                            <div
                                class="o-btn o-btn--fullwidth c-login__button"
                                @click="logIn()"
                            >
                                {{ translations['Log in'] }}
                            </div>
                            <inline-loader></inline-loader>
                        </div>

                        <div
                            class="o-btn o-btn--transparent o-btn--fullwidth"
                            @click="showReset()"
                        >
                            {{ translations['Forgot password'] }}
                        </div>
                    </div>
                </div>
                <div v-if="showResetPassword">
                    <h2>{{ translations['Reset password'] }}</h2>
                    <div class="o-input">
                        <input
                            class="o-input__input"
                            type="text"
                            name="username"
                            id="login-username"
                            required="required"
                            :class="{
                                'o-input__input--filled': username,
                            }"
                            v-model="username"
                        />
                        <div label="o-input__label" for="login-username">
                            {{ translations['Email'] }}
                        </div>
                    </div>
                    <div class="c-login__actions">
                        <div
                            class="c-login__button"
                            :class="{ 'c-login__button--loading': isLoading }"
                        >
                            <div
                                class="o-btn o-btn--fullwidth"
                                @click="resetPassword()"
                            >
                                {{ translations['Reset password'] }}
                            </div>
                            <inline-loader></inline-loader>
                        </div>

                        <div class="return" @click="showLoginForm()">
                            {{ translations['Back to log in form'] }}
                        </div>
                    </div>
                </div>
                <div v-if="passwordReset">
                    <h2>{{ translations['Reset password'] }}</h2>
                    <div>
                        {{
                            translations[
                                'If an account with the given username exists, you will shortly receive a email with an reset link in it.'
                            ]
                        }}
                    </div>
                </div>
            </template>
        </slide-in-overlay>
    </aside>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'

import SlideInOverlay from '../components/SlideInOverlay.vue'
import InlineLoader from './InlineLoader.vue'

export default {
    name: 'Login',
    components: {
        SlideInOverlay,
        InlineLoader,
    },
    data: () => {
        return {
            username: '',
            password: '',
            showLogin: true,
            showResetPassword: false,
            passwordReset: false,
            isLoading: false,
        }
    },
    props: {
        isOpen: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapState({
            cart: (state) => state.cart.cart,
            csrf: (state) => state.app.csrfToken,
            translations: (state) => state.app.translations,
        }),
    },
    methods: {
        close() {
            this.$store.dispatch('account/hideLogin')
            this.showLogin = true
            this.showResetPassword = false
            this.passwordReset = false
        },
        logIn() {
            this.isLoading = true
            let formData = new FormData()
            formData.append('action', 'quantity-extensions/users/login')
            formData.append('CRAFT_CSRF_TOKEN', this.csrf)
            formData.append('loginName', this.username)
            formData.append('password', this.password)

            axios.post(document.location.href, formData).then((response) => {
                this.isLoading = false

                if (response.data.success) {
                    this.$store.dispatch('cart/updateCart', response.data.cart)
                    this.$store.commit(
                        'app/setCsrfToken',
                        response.data.csrfTokenValue
                    )
                    this.close()
                }
            })
        },
        resetPassword() {
            this.isLoading = true
            let formData = new FormData()
            formData.append('action', 'users/send-password-reset-email')
            formData.append('CRAFT_CSRF_TOKEN', this.csrf)
            formData.append('loginName', this.username)

            axios.post(document.location.href, formData).then((response) => {
                // console.log(response)
                this.isLoading = false
                this.passwordReset = true
                this.showResetPassword = false
            })
        },
        showLoginForm() {
            this.showLogin = true
            this.showResetPassword = false
        },
        showReset() {
            this.showLogin = false
            this.showResetPassword = true
        },
    },
}
</script>

<style lang="scss">
@import '../../scss/abstracts/variables.scss';

.c-login {
    .c-slideInOverlay__inner {
        max-width: 400px;
    }

    .o-input {
        margin-top: 17px;
    }

    &__button {
        position: relative;
        margin-bottom: 5px;

        .o-btn {
            white-space: nowrap;
        }

        .o-loaderInline {
            display: none;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            margin-left: -22px;
            z-index: 3;
            div {
                background: $c-white;
            }
        }

        &--loading {
            &::before {
                position: absolute;
                z-index: 2;
                display: block;
                background: $c-black;
                content: '';
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
                border-radius: 30px;
            }

            .o-loaderInline {
                display: inline-block;
            }
        }
    }

    &__actions {
        margin-top: 40px;
        text-align: center;

        .return {
            font-size: 12px;
            text-transform: uppercase;
            font-weight: 700;

            &:hover {
                cursor: pointer;
            }
        }
    }
}
</style>

